import { useTranslation } from '../../../hooks/useTranslation';
import { TranslationKeyEnum } from '../../../types/constants';

const Teams = () => {
  const { t } = useTranslation();
  return <div>{t(TranslationKeyEnum.Teams)}</div>;
};

export default Teams;
